var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('h3', {
    staticClass: "mb-15"
  }, [_vm._v("\n    Compétences socio-professionnelles\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col space-y-5"
  }, [_vm._l(_vm.criterions, function (compSocio, iSocio) {
    return _c('div', {
      key: iSocio,
      staticClass: "flex flex-col space-y-2.5"
    }, [iSocio > 0 || _vm.criterions.length > 1 ? _c('div', {
      staticClass: "mr-2 pt-4"
    }, [_c('delete-button', {
      attrs: {
        "libelle": "Supprimer la compétence"
      },
      on: {
        "del": function ($event) {
          return _vm.deleteCompetence(iSocio);
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "grid grid-cols-6 gap-4",
      attrs: {
        "id": "competencesSocioForm"
      }
    }, [_c('div', {
      staticClass: "col-span-full md:col-span-3 lg:col-span-2"
    }, [_c('input-select', {
      attrs: {
        "name": 'categoriesSocio' + iSocio,
        "libelle": "Catégorie et référentiel",
        "datas": _vm.referentiel,
        "value-is-object": true,
        "value": compSocio.values.categories
      },
      on: {
        "input": function (newValue) {
          if (!_vm.freezeDatas) _vm.getCompetencesAndNiveaux(iSocio, newValue);
        }
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col-span-full md:col-span-3 lg:col-span-2"
    }, [_c('multiple-select', {
      attrs: {
        "name": 'competencesSocio' + iSocio,
        "libelle": "Intitulés",
        "datas": compSocio.datas.competences,
        "value": compSocio.values.competences,
        "value-is-object": true
      },
      on: {
        "input": function (newValue) {
          if (!_vm.freezeDatas) _vm.setSearching('competences', iSocio, newValue);
        }
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col-span-full md:col-span-3 lg:col-span-2"
    }, [_c('input-select', {
      attrs: {
        "name": 'niveauxSocio' + iSocio,
        "libelle": "Niveau (minimum)",
        "datas": compSocio.datas.niveaux,
        "value": compSocio.values.niveaux,
        "value-is-object": true
      },
      on: {
        "input": function (newValue) {
          if (!_vm.freezeDatas) _vm.setSearching('niveaux', iSocio, newValue);
        }
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "flex flex-wrap space-y-2.5 items-baseline",
      attrs: {
        "id": "tagsCompSocio"
      }
    }, [Object.values(compSocio.values.categories).length > 0 ? _c('tag', {
      staticClass: "mr-2.5",
      attrs: {
        "libelle": compSocio.values.categories.value,
        "theme-color": "indigo",
        "is-closeable": true,
        "text-size": "text-sm",
        "text-font": "font-light"
      },
      on: {
        "close": function ($event) {
          return _vm.setSearching('categories', iSocio, {});
        }
      }
    }) : _vm._e(), _vm._v(" "), _vm._l(compSocio.values.competences, function (comp, icomp) {
      return _c('div', {
        key: icomp,
        staticClass: "w-full"
      }, [_c('tag', {
        staticClass: "mr-2.5",
        attrs: {
          "libelle": comp.value,
          "theme-color": "teal",
          "is-closeable": true,
          "text-size": "text-sm",
          "text-font": "font-light",
          "can-truncate": ""
        },
        on: {
          "close": function ($event) {
            return _vm.deleteTheCompetence(iSocio, icomp);
          }
        }
      })], 1);
    }), _vm._v(" "), Object.values(compSocio.values.niveaux).length > 0 ? _c('tag', {
      staticClass: "mr-2.5",
      attrs: {
        "libelle": compSocio.values.niveaux.value,
        "theme-color": "orange",
        "is-closeable": true,
        "text-size": "text-sm",
        "text-font": "font-light"
      },
      on: {
        "close": function ($event) {
          return _vm.setSearching('niveaux', iSocio, {});
        }
      }
    }) : _vm._e()], 2)]);
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "addCompSocioButton"
    }
  }, [_c('add-button', {
    staticClass: "hidden sm:flex",
    attrs: {
      "libelle": "Ajouter une compétence socio-professionnelle"
    },
    on: {
      "add": _vm.addCompetence
    }
  }), _vm._v(" "), _c('add-button', {
    staticClass: "sm:hidden",
    attrs: {
      "libelle": ""
    },
    on: {
      "add": _vm.addCompetence
    }
  })], 1)], 2)]);

}
var staticRenderFns = []

export { render, staticRenderFns }